// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================
   DESIGN TOKENS
====================================== */
:root {
  --bg:            #f0f2f5;
  --surface:       #ffffff;
  --surface-2:     #f7f8fa;
  --border:        #e4e7ed;
  --accent:        #1a73e8;
  --accent-dark:   #1252a3;
  --accent-soft:   #e8f0fe;
  --accent-glow:   rgba(26,115,232,0.20);
  --orange:        #ff6d00;
  --orange-soft:   #fff3e0;
  --danger:        #ef4444;
  --success:       #22c55e;
  --text-primary:  #0f1117;
  --text-secondary:#4b5563;
  --text-muted:    #9ca3af;
  --font:          'Sora', sans-serif;
  --font-mono:     'JetBrains Mono', monospace;
  --ease:          cubic-bezier(0.16, 1, 0.3, 1);
  --radius-sm:     10px;
  --radius-md:     16px;
  --radius-lg:     20px;
  --shadow-sm:     0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04);
  --shadow-md:     0 4px 16px rgba(0,0,0,0.09), 0 12px 32px rgba(0,0,0,0.06);
  --shadow-lg:     0 8px 32px rgba(0,0,0,0.12), 0 32px 64px rgba(0,0,0,0.07);
}

* { box-sizing: border-box; }

/* ======================================
   PAGE SHELL
====================================== */
.shop-div {
  font-family: var(--font);
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  margin-top: 70px;
  background-color: var(--bg);
  padding: 28px 20px 60px;
}

@media (min-width: 1024px) {
  .shop-div {
    padding-top: 32px;
  }
}

/* ======================================
   LAYOUT GRID
====================================== */
.grid-shop {
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin: 0 auto;
  align-items: flex-start;
}

.filter-products-main-box {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  margin: 0;
  max-width: 100%;
  overflow: visible;
}

/* ======================================
   FILTER SIDEBAR
====================================== */
.filter {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  width: 240px;
  min-width: 240px;
  max-width: 240px;
  flex-shrink: 0;
  padding: 16px 14px;
  height: fit-content;
  position: sticky;
  top: 82px;
  transition: box-shadow 0.2s;
  overflow: hidden;
  box-sizing: border-box;
}

.filter:hover {
  box-shadow: var(--shadow-md);
}

.filter-box {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  padding: 0;
  overflow: visible;
  box-sizing: border-box;
}

/* Force all direct filter-box children to stay within sidebar */
.filter-box > * {
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
}

/* Contain FilterDropdown expanded panels inside sidebar */
.filter-box [class*="dropdown"],
.filter-box [class*="Dropdown"],
.filter-box > div {
  width: 100%;
  box-sizing: border-box;
  max-width: 100%;
  overflow: hidden;
}

.filter-box h6 {
  font-family: var(--font);
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--text-muted);
  margin-bottom: 14px;
  margin-top: 18px;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border);
}

.filter-box h6:first-child { margin-top: 0; }

.filter-box span {
  cursor: pointer;
  margin: 6px 0;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text-secondary);
  padding: 7px 10px;
  border-radius: var(--radius-sm);
  transition: all 0.18s var(--ease);
  display: block;
}

.filter-box span:hover {
  background: var(--accent-soft);
  color: var(--accent);
  padding-left: 14px;
}

/* -- Search input (actual class from JS) -- */
.nav-container-navigation {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 6px;
  align-items: center;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  margin-bottom: 10px;
  overflow: hidden;
}

.search-input-navigation {
  flex: 1 1 !important;
  min-width: 0 !important;
  width: 0 !important;
  padding: 7px 10px !important;
  border: 1.5px solid var(--border) !important;
  border-radius: 100px !important;
  font-family: var(--font) !important;
  font-size: 12px !important;
  color: var(--text-primary) !important;
  background: var(--surface-2) !important;
  outline: none !important;
  transition: border-color 0.2s, box-shadow 0.2s !important;
  margin-bottom: 0 !important;
  box-sizing: border-box !important;
}

.search-input-navigation:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
  background: white;
}

/* -- Search button (actual class from JS) -- */
.search-button {
  padding: 6px 10px;
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 10px var(--accent-glow);
  transition: all 0.2s var(--ease);
  white-space: nowrap;
  flex-shrink: 0;
}


/* -- Filter inputs (excluding the top search) -- */
.filter-box > .filter-dropdown input[type="text"],
.filter input[type="text"]:not(.search-input-navigation),
.filter-popup input[type="text"],
.filter-popup select {
  width: 100%;
  padding: 8px 12px;
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  font-family: var(--font);
  font-size: 13px;
  color: var(--text-primary);
  background: var(--surface-2);
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  margin-bottom: 10px;
}

.filter input[type="text"]:not(.search-input-navigation):focus,
.filter-popup input[type="text"]:focus,
.filter-popup select:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
  background: white;
}

/* -- Clear Filters Button -- */
.clear-filters-btn {
  display: block;
  width: 100%;
  padding: 9px 16px;
  text-align: center;
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 14px;
  transition: all 0.25s var(--ease);
  letter-spacing: 0.2px;
  box-shadow: 0 3px 12px var(--accent-glow);
  white-space: nowrap;
}

.clear-filters-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(26,115,232,0.38);
}

/* -- Mobile filter button -- */
.filter-button {
  display: none;
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: white;
  border: none;
  padding: 9px 18px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 10px var(--accent-glow);
  transition: all 0.2s var(--ease);
}

.filter-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px var(--accent-glow);
}

/* ======================================
   SEARCH BAR (top of shop)
====================================== */
.navigation_shop_card {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 6px 14px;
  margin-bottom: 14px;
  margin-top: 4px;
  box-shadow: var(--shadow-sm);
  gap: 12px;
}

.navigation_shop_card input[type="text"] {
  width: 220px;
  flex: none;
  padding: 9px 14px;
  border: 1.5px solid var(--border);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  color: var(--text-primary);
  background: var(--surface-2);
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.navigation_shop_card input[type="text"]:focus {
  border-color: var(--accent);
  box-shadow: 0 0 0 3px var(--accent-soft);
  background: white;
}

.navigation_shop_card button[type="submit"],
.navigation_shop_card .search-btn {
  padding: 10px 22px;
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 10px var(--accent-glow);
  transition: all 0.2s var(--ease);
  white-space: nowrap;
}

.navigation_shop_card button[type="submit"]:hover,
.navigation_shop_card .search-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px var(--accent-glow);
}

/* ======================================
   PRODUCT CARDS CONTAINER
====================================== */
.shop-cards {
  background: transparent;
  border: none;
  flex: 1 1;
  min-width: 0;
}

.shop_js-shop {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 14px;
  justify-content: start;
  align-items: stretch;
}

.my-products {
  flex: 3.3 1;
  display: flex;
  flex-direction: column;
}

/* ======================================
   PRODUCT CARD
====================================== */
.shop_card-shop {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  overflow: hidden;
  position: relative;
  transition: all 0.25s var(--ease);
  box-shadow: var(--shadow-sm);
  display: flex;
  flex-direction: column;
  cursor: pointer;
  animation: cardPop 0.3s var(--ease) both;
}

@keyframes cardPop {
  from { opacity: 0; transform: translateY(10px) scale(0.98); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.shop_card-shop:hover {
  transform: translateY(-5px);
  box-shadow: var(--shadow-md);
  border-color: var(--border-hover, #c4c9d4);
}

/* Top accent stripe on hover */
.shop_card-shop::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(90deg, var(--accent), #4a9af5);
  transform: scaleX(0);
  transition: transform 0.25s var(--ease);
  z-index: 1;
}

.shop_card-shop:hover::before {
  transform: scaleX(1);
}

/* -- Product Image -- */
.card-image-shop {
  width: 100%;
  height: 95px;
  object-fit: contain;
  background: var(--surface-2);
  padding: 6px;
  box-sizing: border-box;
  transition: transform 0.3s var(--ease);
  display: block;
  flex-shrink: 0;
}

.shop_card-shop:hover .card-image-shop {
  transform: scale(1.06);
}

/* -- Wishlist Heart Button -- */
/* Wishlist icon - lives inside .card-text-shop p, float it to top-right of card */
.wishlist-icon-shop {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 26px;
  height: 26px;
  background: white;
  border: 1px solid var(--border);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 6px rgba(0,0,0,0.10);
  z-index: 3;
  transition: all 0.2s var(--ease);
  color: var(--text-muted);
}

.wishlist-icon-shop:hover {
  background: #fff0f0;
  border-color: #ffb3b3;
  color: var(--danger);
  transform: scale(1.1);
  box-shadow: 0 3px 10px rgba(239,68,68,0.18);
}

.heart_btn-shop {
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Override the inline fontSize:'21px' on FaHeart/FiHeart */
.wishlist-icon-shop .heart_btn-shop svg,
.wishlist-icon-shop .heart_btn-shop * {
  font-size: 13px !important;
  width: 13px !important;
  height: 13px !important;
}

.heart_btn-shop i { font-size: 12px; transition: color 0.2s; }

.wishlisted .wishlist-icon-shop,
.wishlisted .heart_btn-shop i,
.wishlisted .fa-heart {
  color: var(--danger) !important;
}

/* -- Card Content -- */
.shop_container-shop {
  padding: 8px 10px 10px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 1px;
  text-align: left !important;
}

/* Override inline justify from JS */
.shop_container-shop[style] {
  text-align: left !important;
}

/* Override ALL inline font sizes set directly in JSX */
.shop_container-shop a[style] {
  font-family: var(--font) !important;
  text-decoration: none !important;
}

/* Product name (fontSize:"14pt" inline) */
.shop_container-shop > a:first-of-type {
  font-size: 12.5px !important;
  font-weight: 700 !important;
  color: var(--text-primary) !important;
  display: block !important;
  line-height: 1.3 !important;
}

/* Description (fontSize:"7pt" inline) */
.shop_container-shop > a:nth-of-type(2) {
  font-size: 10px !important;
  color: var(--text-muted) !important;
  display: block !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

/* Store name (fontSize:"11pt" inline) */
.shop_container-shop > a:nth-of-type(3) {
  font-size: 11px !important;
  color: var(--text-secondary) !important;
  display: block !important;
}

/* City span (fontSize:"10pt" inline) */
.shop_container-shop > span[style] {
  font-size: 10px !important;
  display: flex !important;
  align-items: center !important;
  color: var(--text-muted) !important;
}

/* Price b (fontSize:"12pt" inline) */
.card-text-shop b[style] {
  font-size: 13px !important;
  font-weight: 800 !important;
  font-family: var(--font) !important;
}

/* Discount % span */
.card-text-shop span[style*="green"] {
  font-size: 10.5px !important;
  padding: 2px 0 !important;
  color: var(--success) !important;
}

/* MRP strikethrough */
.card-text-shop span[style*="line-through"] {
  font-size: 10px !important;
  color: var(--text-muted) !important;
}

/* br tags cause unwanted spacing - collapse them */
.shop_container-shop br { display: none !important; }

/* Push cart button to bottom always */
.cart-btn-shop {
  margin-top: auto !important;
}

.card-text-shop {
  display: flex;
  flex-direction: column;
  gap: 3px;
  flex: 1 1;
}

/* Product name */
.card-text-shop .product-name,
.shop_card-shop h5,
.shop_card-shop .product-title,
.shop_container-shop b,
.shop_container-shop strong {
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.25;
  margin: 0 0 1px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: left;
  word-break: normal;
  word-spacing: normal;
}

/* Description / variant */
.card-text-shop .product-desc,
.shop_card-shop .product-variant {
  font-size: 10.5px;
  color: var(--text-muted);
  font-weight: 400;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Category */
.card-text-shop .product-category,
.shop_card-shop .category-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Location */
.card-text-shop .product-location {
  font-size: 10.5px;
  color: var(--text-muted);
  display: flex;
  align-items: center;
  gap: 4px;
}

/* Price row */
.card-text-shop .price-row {
  display: flex;
  align-items: baseline;
  gap: 4px;
  margin-top: 4px;
  flex-wrap: wrap;
}

.price-discounted {
  font-size: 13px;
  font-weight: 800;
  color: var(--text-primary);
  font-family: var(--font);
}

.price-discount-pct {
  font-size: 10.5px;
  font-weight: 700;
  color: var(--success);
  background: var(--success-soft, #f0fdf4);
  padding: 1px 6px;
  border-radius: 100px;
  white-space: nowrap;
}

.price-mrp {
  font-size: 10.5px;
  color: var(--text-muted);
  text-decoration: line-through;
  font-weight: 400;
}

/* -- Add to Cart Button -- */
.cart-btn-shop {
  width: 100%;
  padding: 8px 12px;
  background: linear-gradient(135deg, var(--orange) 0%, #e65100 100%);
  color: white;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
  margin-top: auto;
  transition: all 0.22s var(--ease);
  box-shadow: 0 3px 10px rgba(255,109,0,0.28);
  letter-spacing: 0.2px;
  display: block;
  flex-shrink: 0;
}

.cart-btn-shop:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(255,109,0,0.4);
}

.cart-btn-shop:active { transform: translateY(0); }

/* ======================================
   FILTER CHIPS
====================================== */
.filter-chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 16px;
  padding: 0;
}

.filter-chip,
.location-filter-chip,
.city-filter-chip,
.merchant-filter-chip,
.category-filter-chip,
.search-filter-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--surface);
  border: 1.5px solid var(--border);
  border-radius: 100px;
  padding: 5px 12px;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text-secondary);
  box-shadow: var(--shadow-sm);
  transition: all 0.18s var(--ease);
}

.location-filter-chip,
.city-filter-chip   { border-color: var(--accent); color: var(--accent); background: var(--accent-soft); }
.merchant-filter-chip { border-color: var(--orange); color: var(--orange); background: var(--orange-soft); }
.category-filter-chip { border-color: var(--success); color: var(--success); background: #f0fdf4; }
.search-filter-chip   { border-color: var(--danger); color: var(--danger); background: #fef2f2; }

.chip-close-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: currentColor;
  opacity: 0.6;
  font-size: 13px;
  display: flex;
  align-items: center;
  transition: opacity 0.15s, transform 0.15s;
  line-height: 1;
}

.chip-close-button:hover {
  opacity: 1;
  transform: scale(1.2);
}

.clear-all-filters {
  background: white;
  border: 1.5px solid var(--border);
  border-radius: 100px;
  padding: 5px 14px;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  color: var(--accent);
  cursor: pointer;
  transition: all 0.18s var(--ease);
  box-shadow: var(--shadow-sm);
}

.clear-all-filters:hover {
  background: var(--accent-soft);
  border-color: var(--accent);
  transform: translateY(-1px);
}

/* ======================================
   PAGINATION
====================================== */
.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  margin: 32px 0 16px;
  flex-wrap: wrap;
}

.pagination-container button {
  min-width: 38px;
  height: 38px;
  padding: 0 12px;
  border: 1.5px solid var(--border);
  background: var(--surface);
  color: var(--text-primary);
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 100px;
  box-shadow: var(--shadow-sm);
  transition: all 0.18s var(--ease);
}

.pagination-container button:hover:not(:disabled) {
  background: var(--accent-soft);
  border-color: var(--accent);
  color: var(--accent);
  transform: translateY(-1px);
}

.pagination-container button.active,
.pagination-container button[aria-current="page"] {
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  border-color: var(--accent);
  color: white;
  box-shadow: 0 3px 10px var(--accent-glow);
}

.pagination-container button:disabled {
  background: var(--surface-2);
  color: var(--text-muted);
  cursor: not-allowed;
  border-color: var(--border);
  box-shadow: none;
}

.pagination-container span {
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  color: var(--text-secondary);
  padding: 0 8px;
}

/* ======================================
   LOADING SPINNER
====================================== */
.flipkart-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 240px;
}

.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spinner {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 3px solid var(--accent-soft);
  border-top-color: var(--accent);
  animation: spin 0.7s linear infinite;
  box-shadow: 0 0 16px var(--accent-glow);
}

.small-spinner {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: white;
  animation: spin 0.7s linear infinite;
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}

@keyframes spin { to { transform: rotate(360deg); } }

.loading-text {
  font-family: var(--font);
  font-size: 13px;
  font-weight: 600;
  color: var(--accent);
  letter-spacing: 0.3px;
}

/* ======================================
   SKELETON LOADING
====================================== */
.flipkart-loading-skeleton {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 16px;
  padding: 0;
}

.product-skeleton {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  padding: 12px;
  overflow: hidden;
}

.skeleton-image,
.skeleton-line,
.skeleton-button {
  background: linear-gradient(90deg, #f0f2f5 25%, #e4e7ed 50%, #f0f2f5 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
  border-radius: var(--radius-sm);
}

.skeleton-image { width: 100%; height: 160px; margin-bottom: 14px; }
.skeleton-line  { height: 11px; margin-bottom: 8px; }
.skeleton-line.short  { width: 55%; }
.skeleton-line.medium { width: 75%; }
.skeleton-line.long   { width: 90%; }
.skeleton-button      { height: 34px; width: 100%; margin-top: 14px; border-radius: 100px; }

@keyframes shimmer {
  0%   { background-position: -200% 0; }
  100% { background-position:  200% 0; }
}

/* ======================================
   EMPTY / ERROR STATES
====================================== */
.no-items-found-container,
.no-results-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  margin: 8px 0;
}

.no-items-found-illustration,
.no-results-icon { font-size: 48px; margin-bottom: 16px; opacity: 0.5; }

.no-items-found-title,
.no-results-message h3 {
  font-family: var(--font);
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.no-items-found-message,
.no-results-message p {
  font-size: 13.5px;
  color: var(--text-secondary);
  line-height: 1.6;
  max-width: 320px;
  margin-bottom: 20px;
}

.simple-error-message,
.immediate-error-message {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  background: #fef2f2;
  border: 1px solid rgba(239,68,68,0.25);
  border-radius: var(--radius-sm);
  margin: 16px 0;
  animation: fadeIn 0.2s ease;
}

.error-icon {
  width: 26px;
  height: 26px;
  background: var(--danger);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  flex-shrink: 0;
  font-size: 13px;
}

.error-text {
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 500;
  color: #b91c1c;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-4px); }
  to   { opacity: 1; transform: translateY(0); }
}

/* ======================================
   WISHLIST TOAST POPUP
====================================== */
.wishlist-popup-shop {
  position: fixed;
  top: 88px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(15,17,23,0.88);
  backdrop-filter: blur(8px);
  color: white;
  padding: 12px 22px;
  border-radius: 100px;
  z-index: 9999;
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 600;
  letter-spacing: 0.2px;
  box-shadow: var(--shadow-lg);
  white-space: nowrap;
  animation: toastIn 0.25s var(--ease);
}

@keyframes toastIn {
  from { opacity: 0; transform: translateX(-50%) translateY(-8px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}

.goto-cart-button-shop {
  background: var(--accent);
  border: none;
  color: white;
  padding: 6px 16px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  border-radius: 100px;
  cursor: pointer;
  margin-left: 12px;
  transition: all 0.18s var(--ease);
}

.goto-cart-button-shop:hover {
  background: var(--accent-dark);
  transform: translateY(-1px);
}

/* ======================================
   FILTER POPUP (mobile overlay)
====================================== */
.filter-popup {
  display: none;
  position: fixed;
  inset: 0;
  background: rgba(15,17,23,0.45);
  backdrop-filter: blur(5px);
  z-index: 102;
  overflow-y: auto;
}

.filter-popup.open {
  display: flex;
  justify-content: center;
  align-items: center;
}

.filter-popup-content {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 28px 24px;
  width: 90%;
  max-width: 480px;
  box-shadow: var(--shadow-lg);
  animation: modalIn 0.25s var(--ease);
}

@keyframes modalIn {
  from { opacity: 0; transform: scale(0.95) translateY(12px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}

.filter-popup label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: var(--text-muted);
  font-family: var(--font);
  margin-bottom: 6px;
}

.filter-popup button[type="submit"] {
  background: linear-gradient(135deg, var(--accent), var(--accent-dark));
  color: white;
  padding: 11px 22px;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 3px 10px var(--accent-glow);
  transition: all 0.2s var(--ease);
  margin-top: 12px;
}

.filter-popup button[type="submit"]:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px var(--accent-glow);
}

.filter-popup .close-button,
.close-filter-button {
  background: var(--surface-2);
  color: var(--text-secondary);
  border: 1.5px solid var(--border);
  padding: 11px 18px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  margin-left: 10px;
  transition: all 0.18s var(--ease);
}

.filter-popup .close-button:hover,
.close-filter-button:hover {
  background: var(--border);
  color: var(--text-primary);
}

/* ======================================
   FILTER REC BUTTONS
====================================== */
.filter-rec-btn-s {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
}

.filter-rec-btn-s button {
  background: var(--surface-2);
  border: 1.5px solid var(--border);
  color: var(--text-secondary);
  font-family: var(--font);
  font-size: 12px;
  font-weight: 600;
  padding: 5px 12px;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.18s var(--ease);
}

.filter-rec-btn-s button:hover {
  background: var(--accent-soft);
  border-color: var(--accent);
  color: var(--accent);
}

/* ======================================
   NAV ICON
====================================== */
.nav-icons-navbar-s {
  height: 36px;
  margin-right: 0;
  font-size: 20px;
  color: var(--text-secondary);
  transition: color 0.18s;
}

.nav-icons-navbar-s:hover { color: var(--accent); }

/* ======================================
   ADD CARD BUTTON
====================================== */
.add-card-button {
  padding: 10px 22px;
  background: linear-gradient(135deg, var(--orange), #e65100);
  color: white;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 3px 10px rgba(255,109,0,0.28);
  transition: all 0.2s var(--ease);
  margin-left: auto;
  display: block;
  white-space: nowrap;
}

.add-card-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(255,109,0,0.38);
}

/* ======================================
   RESPONSIVE
====================================== */
@media (max-width: 1024px) and (min-width: 768px) {
  .shop_js-shop { grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 12px; }
  .card-image-shop { height: 155px; }
  .filter { width: 220px; }
}

@media (max-width: 768px) {
  .shop-div { margin-top: 70px; padding: 16px 12px 48px; }

  .filter-products-main-box { flex-direction: column; }

  .filter {
    position: fixed;
    top: 70px;
    left: -280px;
    width: 260px;
    max-height: 90vh;
    z-index: 100;
    overflow-y: auto;
    border-radius: 0 var(--radius-lg) var(--radius-lg) 0;
    transition: left 0.3s var(--ease);
  }

  .filter.open { left: 0; }

  .filter-button { display: flex; align-items: center; gap: 6px; }

  .navigation_shop_card {
    flex-wrap: wrap;
    border-radius: var(--radius-sm);
    padding: 10px 12px;
    gap: 8px;
  }

  .shop_js-shop {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .card-image-shop { height: 150px; }

  .shop_card-shop { border-radius: var(--radius-sm); }
}

@media (max-width: 480px) {
  .shop_js-shop { grid-template-columns: repeat(2, 1fr); gap: 8px; }
  .card-image-shop { height: 130px; }
  .shop_container-shop { padding: 9px 10px 11px; }
  .cart-btn-shop { font-size: 11.5px; padding: 9px 10px; }
  .price-discounted { font-size: 14px; }
  .shop-div { padding: 12px 8px 40px; }
}
/* ── Shop page star rating badge (Flipkart/Amazon style) ── */
.shop-star-rating {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 3px 0 5px;
}

.shop-star-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  background: #388e3c;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 3px;
  line-height: 1.5;
}

.shop-star-icon {
  font-size: 11px;
  line-height: 1;
}

.shop-rating-count {
  font-size: 11.5px;
  color: #878787;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/shop.css"],"names":[],"mappings":"AAEA;;wCAEwC;AACxC;EACE,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,sCAAsC;EACtC,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,wBAAwB;EACxB,mCAAmC;EACnC,4CAA4C;EAC5C,8CAA8C;EAC9C,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,wEAAwE;EACxE,0EAA0E;EAC1E,0EAA0E;AAC5E;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;;wCAEwC;AACxC;EACE,wBAAwB;EACxB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,UAAU;EACV,SAAS;EACT,eAAe;EACf,iBAAiB;AACnB;;AAEA;;wCAEwC;AACxC;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,gEAAgE;AAChE;EACE,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA,0DAA0D;AAC1D;;;EAGE,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA,6BAA6B,aAAa,EAAE;;AAE5C;EACE,eAAe;EACf,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,4CAA4C;EAC5C,+BAA+B;EAC/B,mCAAmC;EACnC,0BAA0B;EAC1B,qCAAqC;EACrC,uCAAuC;EACvC,wBAAwB;EACxB,yDAAyD;EACzD,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,sEAAsE;EACtE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;;AAGA,mDAAmD;AACnD;;;;EAIE,WAAW;EACX,iBAAiB;EACjB,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,+DAA+D;EAC/D,mBAAmB;AACrB;;AAEA;;;EAGE,2BAA2B;EAC3B,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sEAAsE;EACtE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,sEAAsE;EACtE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,4BAA4B;EAC5B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,iCAAiC;EACjC,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,0BAA0B;EAC1B,4BAA4B;EAC5B,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,sEAAsE;EACtE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;;wCAEwC;AACxC;EACE,uBAAuB;EACvB,YAAY;EACZ,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,WAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;;wCAEwC;AACxC;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,QAAQ;EACzB,WAAW;EACX,0DAA0D;EAC1D,oBAAoB;EACpB,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,YAAY;EACZ,sBAAsB;EACtB,sCAAsC;EACtC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;AAChC,kFAAkF;AAClF;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,UAAU;EACV,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;;EAEE,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,oBAAoB,eAAe,EAAE,sBAAsB,EAAE;;AAE7D;;;EAGE,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,2BAA2B;AAC7B;;AAEA,uDAAuD;AACvD;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA,0CAA0C;AAC1C;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,qCAAqC;EACrC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,yBAAyB;EACzB,8BAA8B;EAC9B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA,wCAAwC;AACxC;EACE,0BAA0B;EAC1B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA,uCAAuC;AACvC;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA,qCAAqC;AACrC;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,oBAAoB;AACpB;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;;AAEA,mDAAmD;AACnD,0BAA0B,wBAAwB,EAAE;;AAEpD,sCAAsC;AACtC;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA,iBAAiB;AACjB;;;;;EAKE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;;EAEE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,aAAa;AACb;;EAEE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,cAAc;AACd;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;EACxC,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,iBAAiB;EACjB,mEAAmE;EACnE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,2CAA2C;EAC3C,qBAAqB;EACrB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,wBAAwB,wBAAwB,EAAE;;AAElD;;wCAEwC;AACxC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;;;EAME,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;sBACsB,2BAA2B,EAAE,oBAAoB,EAAE,8BAA8B,EAAE;AACzG,wBAAwB,2BAA2B,EAAE,oBAAoB,EAAE,8BAA8B,EAAE;AAC3G,wBAAwB,4BAA4B,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;AAClG,wBAAwB,2BAA2B,EAAE,oBAAoB,EAAE,mBAAmB,EAAE;;AAEhG;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,oBAAoB;EACpB,iBAAiB;EACjB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;;EAEE,sEAAsE;EACtE,2BAA2B;EAC3B,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,+BAA+B;EAC/B,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,uBAAuB;EACvB,oCAAoC;EACpC,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,kBAAkB,KAAK,yBAAyB,EAAE,EAAE;;AAEpD;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA,kBAAkB,WAAW,EAAE,aAAa,EAAE,mBAAmB,EAAE;AACnE,kBAAkB,YAAY,EAAE,kBAAkB,EAAE;AACpD,wBAAwB,UAAU,EAAE;AACpC,wBAAwB,UAAU,EAAE;AACpC,wBAAwB,UAAU,EAAE;AACpC,wBAAwB,YAAY,EAAE,WAAW,EAAE,gBAAgB,EAAE,oBAAoB,EAAE;;AAE3F;EACE,OAAO,4BAA4B,EAAE;EACrC,OAAO,4BAA4B,EAAE;AACvC;;AAEA;;wCAEwC;AACxC;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;mBACmB,eAAe,EAAE,mBAAmB,EAAE,YAAY,EAAE;;AAEvE;;EAEE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,+BAA+B;EAC/B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;;wCAEwC;AACxC;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,+BAA+B;EAC/B,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,4BAA4B;EAC5B,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,4CAA4C,EAAE;EACjE,OAAO,UAAU,EAAE,yCAAyC,EAAE;AAChE;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,0BAA0B;EAC1B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,sEAAsE;EACtE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;;EAEE,4BAA4B;EAC5B,4BAA4B;EAC5B,iCAAiC;EACjC,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,4BAA4B;EAC5B,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;wCAEwC;AACxC;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA,4BAA4B,oBAAoB,EAAE;;AAElD;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,2DAA2D;EAC3D,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;wCAEwC;AACxC;EACE,gBAAgB,4DAA4D,EAAE,SAAS,EAAE;EACzF,mBAAmB,aAAa,EAAE;EAClC,UAAU,YAAY,EAAE;AAC1B;;AAEA;EACE,YAAY,gBAAgB,EAAE,uBAAuB,EAAE;;EAEvD,4BAA4B,sBAAsB,EAAE;;EAEpD;IACE,eAAe;IACf,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,oDAAoD;IACpD,iCAAiC;EACnC;;EAEA,eAAe,OAAO,EAAE;;EAExB,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;;EAE/D;IACE,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,qCAAqC;IACrC,SAAS;EACX;;EAEA,mBAAmB,aAAa,EAAE;;EAElC,kBAAkB,+BAA+B,EAAE;AACrD;;AAEA;EACE,gBAAgB,qCAAqC,EAAE,QAAQ,EAAE;EACjE,mBAAmB,aAAa,EAAE;EAClC,uBAAuB,sBAAsB,EAAE;EAC/C,iBAAiB,iBAAiB,EAAE,iBAAiB,EAAE;EACvD,oBAAoB,eAAe,EAAE;EACrC,YAAY,sBAAsB,EAAE;AACtC;AACA,8DAA8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap');\n\n/* ======================================\n   DESIGN TOKENS\n====================================== */\n:root {\n  --bg:            #f0f2f5;\n  --surface:       #ffffff;\n  --surface-2:     #f7f8fa;\n  --border:        #e4e7ed;\n  --accent:        #1a73e8;\n  --accent-dark:   #1252a3;\n  --accent-soft:   #e8f0fe;\n  --accent-glow:   rgba(26,115,232,0.20);\n  --orange:        #ff6d00;\n  --orange-soft:   #fff3e0;\n  --danger:        #ef4444;\n  --success:       #22c55e;\n  --text-primary:  #0f1117;\n  --text-secondary:#4b5563;\n  --text-muted:    #9ca3af;\n  --font:          'Sora', sans-serif;\n  --font-mono:     'JetBrains Mono', monospace;\n  --ease:          cubic-bezier(0.16, 1, 0.3, 1);\n  --radius-sm:     10px;\n  --radius-md:     16px;\n  --radius-lg:     20px;\n  --shadow-sm:     0 1px 3px rgba(0,0,0,0.06), 0 4px 12px rgba(0,0,0,0.04);\n  --shadow-md:     0 4px 16px rgba(0,0,0,0.09), 0 12px 32px rgba(0,0,0,0.06);\n  --shadow-lg:     0 8px 32px rgba(0,0,0,0.12), 0 32px 64px rgba(0,0,0,0.07);\n}\n\n* { box-sizing: border-box; }\n\n/* ======================================\n   PAGE SHELL\n====================================== */\n.shop-div {\n  font-family: var(--font);\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n  margin-top: 70px;\n  background-color: var(--bg);\n  padding: 28px 20px 60px;\n}\n\n@media (min-width: 1024px) {\n  .shop-div {\n    padding-top: 32px;\n  }\n}\n\n/* ======================================\n   LAYOUT GRID\n====================================== */\n.grid-shop {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  margin: 0 auto;\n  align-items: flex-start;\n}\n\n.filter-products-main-box {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0;\n  margin: 0;\n  max-width: 100%;\n  overflow: visible;\n}\n\n/* ======================================\n   FILTER SIDEBAR\n====================================== */\n.filter {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  width: 240px;\n  min-width: 240px;\n  max-width: 240px;\n  flex-shrink: 0;\n  padding: 16px 14px;\n  height: fit-content;\n  position: sticky;\n  top: 82px;\n  transition: box-shadow 0.2s;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.filter:hover {\n  box-shadow: var(--shadow-md);\n}\n\n.filter-box {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  padding: 0;\n  overflow: visible;\n  box-sizing: border-box;\n}\n\n/* Force all direct filter-box children to stay within sidebar */\n.filter-box > * {\n  width: 100%;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n/* Contain FilterDropdown expanded panels inside sidebar */\n.filter-box [class*=\"dropdown\"],\n.filter-box [class*=\"Dropdown\"],\n.filter-box > div {\n  width: 100%;\n  box-sizing: border-box;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.filter-box h6 {\n  font-family: var(--font);\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  color: var(--text-muted);\n  margin-bottom: 14px;\n  margin-top: 18px;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--border);\n}\n\n.filter-box h6:first-child { margin-top: 0; }\n\n.filter-box span {\n  cursor: pointer;\n  margin: 6px 0;\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  padding: 7px 10px;\n  border-radius: var(--radius-sm);\n  transition: all 0.18s var(--ease);\n  display: block;\n}\n\n.filter-box span:hover {\n  background: var(--accent-soft);\n  color: var(--accent);\n  padding-left: 14px;\n}\n\n/* -- Search input (actual class from JS) -- */\n.nav-container-navigation {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  gap: 6px;\n  align-items: center;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n\n.search-input-navigation {\n  flex: 1 1 0% !important;\n  min-width: 0 !important;\n  width: 0 !important;\n  padding: 7px 10px !important;\n  border: 1.5px solid var(--border) !important;\n  border-radius: 100px !important;\n  font-family: var(--font) !important;\n  font-size: 12px !important;\n  color: var(--text-primary) !important;\n  background: var(--surface-2) !important;\n  outline: none !important;\n  transition: border-color 0.2s, box-shadow 0.2s !important;\n  margin-bottom: 0 !important;\n  box-sizing: border-box !important;\n}\n\n.search-input-navigation:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n  background: white;\n}\n\n/* -- Search button (actual class from JS) -- */\n.search-button {\n  padding: 6px 10px;\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 11px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 3px 10px var(--accent-glow);\n  transition: all 0.2s var(--ease);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n\n/* -- Filter inputs (excluding the top search) -- */\n.filter-box > .filter-dropdown input[type=\"text\"],\n.filter input[type=\"text\"]:not(.search-input-navigation),\n.filter-popup input[type=\"text\"],\n.filter-popup select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--text-primary);\n  background: var(--surface-2);\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;\n  margin-bottom: 10px;\n}\n\n.filter input[type=\"text\"]:not(.search-input-navigation):focus,\n.filter-popup input[type=\"text\"]:focus,\n.filter-popup select:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n  background: white;\n}\n\n/* -- Clear Filters Button -- */\n.clear-filters-btn {\n  display: block;\n  width: 100%;\n  padding: 9px 16px;\n  text-align: center;\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 14px;\n  transition: all 0.25s var(--ease);\n  letter-spacing: 0.2px;\n  box-shadow: 0 3px 12px var(--accent-glow);\n  white-space: nowrap;\n}\n\n.clear-filters-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(26,115,232,0.38);\n}\n\n/* -- Mobile filter button -- */\n.filter-button {\n  display: none;\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\n  color: white;\n  border: none;\n  padding: 9px 18px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 3px 10px var(--accent-glow);\n  transition: all 0.2s var(--ease);\n}\n\n.filter-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px var(--accent-glow);\n}\n\n/* ======================================\n   SEARCH BAR (top of shop)\n====================================== */\n.navigation_shop_card {\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 6px 14px;\n  margin-bottom: 14px;\n  margin-top: 4px;\n  box-shadow: var(--shadow-sm);\n  gap: 12px;\n}\n\n.navigation_shop_card input[type=\"text\"] {\n  width: 220px;\n  flex: none;\n  padding: 9px 14px;\n  border: 1.5px solid var(--border);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--text-primary);\n  background: var(--surface-2);\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.navigation_shop_card input[type=\"text\"]:focus {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 3px var(--accent-soft);\n  background: white;\n}\n\n.navigation_shop_card button[type=\"submit\"],\n.navigation_shop_card .search-btn {\n  padding: 10px 22px;\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 3px 10px var(--accent-glow);\n  transition: all 0.2s var(--ease);\n  white-space: nowrap;\n}\n\n.navigation_shop_card button[type=\"submit\"]:hover,\n.navigation_shop_card .search-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px var(--accent-glow);\n}\n\n/* ======================================\n   PRODUCT CARDS CONTAINER\n====================================== */\n.shop-cards {\n  background: transparent;\n  border: none;\n  flex: 1;\n  min-width: 0;\n}\n\n.shop_js-shop {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 14px;\n  justify-content: start;\n  align-items: stretch;\n}\n\n.my-products {\n  flex: 3.3;\n  display: flex;\n  flex-direction: column;\n}\n\n/* ======================================\n   PRODUCT CARD\n====================================== */\n.shop_card-shop {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n  position: relative;\n  transition: all 0.25s var(--ease);\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  animation: cardPop 0.3s var(--ease) both;\n}\n\n@keyframes cardPop {\n  from { opacity: 0; transform: translateY(10px) scale(0.98); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.shop_card-shop:hover {\n  transform: translateY(-5px);\n  box-shadow: var(--shadow-md);\n  border-color: var(--border-hover, #c4c9d4);\n}\n\n/* Top accent stripe on hover */\n.shop_card-shop::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; right: 0;\n  height: 3px;\n  background: linear-gradient(90deg, var(--accent), #4a9af5);\n  transform: scaleX(0);\n  transition: transform 0.25s var(--ease);\n  z-index: 1;\n}\n\n.shop_card-shop:hover::before {\n  transform: scaleX(1);\n}\n\n/* -- Product Image -- */\n.card-image-shop {\n  width: 100%;\n  height: 95px;\n  object-fit: contain;\n  background: var(--surface-2);\n  padding: 6px;\n  box-sizing: border-box;\n  transition: transform 0.3s var(--ease);\n  display: block;\n  flex-shrink: 0;\n}\n\n.shop_card-shop:hover .card-image-shop {\n  transform: scale(1.06);\n}\n\n/* -- Wishlist Heart Button -- */\n/* Wishlist icon - lives inside .card-text-shop p, float it to top-right of card */\n.wishlist-icon-shop {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 26px;\n  height: 26px;\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 1px 6px rgba(0,0,0,0.10);\n  z-index: 3;\n  transition: all 0.2s var(--ease);\n  color: var(--text-muted);\n}\n\n.wishlist-icon-shop:hover {\n  background: #fff0f0;\n  border-color: #ffb3b3;\n  color: var(--danger);\n  transform: scale(1.1);\n  box-shadow: 0 3px 10px rgba(239,68,68,0.18);\n}\n\n.heart_btn-shop {\n  background: none;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Override the inline fontSize:'21px' on FaHeart/FiHeart */\n.wishlist-icon-shop .heart_btn-shop svg,\n.wishlist-icon-shop .heart_btn-shop * {\n  font-size: 13px !important;\n  width: 13px !important;\n  height: 13px !important;\n}\n\n.heart_btn-shop i { font-size: 12px; transition: color 0.2s; }\n\n.wishlisted .wishlist-icon-shop,\n.wishlisted .heart_btn-shop i,\n.wishlisted .fa-heart {\n  color: var(--danger) !important;\n}\n\n/* -- Card Content -- */\n.shop_container-shop {\n  padding: 8px 10px 10px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  text-align: left !important;\n}\n\n/* Override inline justify from JS */\n.shop_container-shop[style] {\n  text-align: left !important;\n}\n\n/* Override ALL inline font sizes set directly in JSX */\n.shop_container-shop a[style] {\n  font-family: var(--font) !important;\n  text-decoration: none !important;\n}\n\n/* Product name (fontSize:\"14pt\" inline) */\n.shop_container-shop > a:first-of-type {\n  font-size: 12.5px !important;\n  font-weight: 700 !important;\n  color: var(--text-primary) !important;\n  display: block !important;\n  line-height: 1.3 !important;\n}\n\n/* Description (fontSize:\"7pt\" inline) */\n.shop_container-shop > a:nth-of-type(2) {\n  font-size: 10px !important;\n  color: var(--text-muted) !important;\n  display: block !important;\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n/* Store name (fontSize:\"11pt\" inline) */\n.shop_container-shop > a:nth-of-type(3) {\n  font-size: 11px !important;\n  color: var(--text-secondary) !important;\n  display: block !important;\n}\n\n/* City span (fontSize:\"10pt\" inline) */\n.shop_container-shop > span[style] {\n  font-size: 10px !important;\n  display: flex !important;\n  align-items: center !important;\n  color: var(--text-muted) !important;\n}\n\n/* Price b (fontSize:\"12pt\" inline) */\n.card-text-shop b[style] {\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  font-family: var(--font) !important;\n}\n\n/* Discount % span */\n.card-text-shop span[style*=\"green\"] {\n  font-size: 10.5px !important;\n  padding: 2px 0 !important;\n  color: var(--success) !important;\n}\n\n/* MRP strikethrough */\n.card-text-shop span[style*=\"line-through\"] {\n  font-size: 10px !important;\n  color: var(--text-muted) !important;\n}\n\n/* br tags cause unwanted spacing - collapse them */\n.shop_container-shop br { display: none !important; }\n\n/* Push cart button to bottom always */\n.cart-btn-shop {\n  margin-top: auto !important;\n}\n\n.card-text-shop {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  flex: 1;\n}\n\n/* Product name */\n.card-text-shop .product-name,\n.shop_card-shop h5,\n.shop_card-shop .product-title,\n.shop_container-shop b,\n.shop_container-shop strong {\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--text-primary);\n  line-height: 1.25;\n  margin: 0 0 1px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-align: left;\n  word-break: normal;\n  word-spacing: normal;\n}\n\n/* Description / variant */\n.card-text-shop .product-desc,\n.shop_card-shop .product-variant {\n  font-size: 10.5px;\n  color: var(--text-muted);\n  font-weight: 400;\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* Category */\n.card-text-shop .product-category,\n.shop_card-shop .category-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n/* Location */\n.card-text-shop .product-location {\n  font-size: 10.5px;\n  color: var(--text-muted);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* Price row */\n.card-text-shop .price-row {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  margin-top: 4px;\n  flex-wrap: wrap;\n}\n\n.price-discounted {\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--text-primary);\n  font-family: var(--font);\n}\n\n.price-discount-pct {\n  font-size: 10.5px;\n  font-weight: 700;\n  color: var(--success);\n  background: var(--success-soft, #f0fdf4);\n  padding: 1px 6px;\n  border-radius: 100px;\n  white-space: nowrap;\n}\n\n.price-mrp {\n  font-size: 10.5px;\n  color: var(--text-muted);\n  text-decoration: line-through;\n  font-weight: 400;\n}\n\n/* -- Add to Cart Button -- */\n.cart-btn-shop {\n  width: 100%;\n  padding: 8px 12px;\n  background: linear-gradient(135deg, var(--orange) 0%, #e65100 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 11.5px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: auto;\n  transition: all 0.22s var(--ease);\n  box-shadow: 0 3px 10px rgba(255,109,0,0.28);\n  letter-spacing: 0.2px;\n  display: block;\n  flex-shrink: 0;\n}\n\n.cart-btn-shop:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 18px rgba(255,109,0,0.4);\n}\n\n.cart-btn-shop:active { transform: translateY(0); }\n\n/* ======================================\n   FILTER CHIPS\n====================================== */\n.filter-chips-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0 0 16px;\n  padding: 0;\n}\n\n.filter-chip,\n.location-filter-chip,\n.city-filter-chip,\n.merchant-filter-chip,\n.category-filter-chip,\n.search-filter-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--surface);\n  border: 1.5px solid var(--border);\n  border-radius: 100px;\n  padding: 5px 12px;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  box-shadow: var(--shadow-sm);\n  transition: all 0.18s var(--ease);\n}\n\n.location-filter-chip,\n.city-filter-chip   { border-color: var(--accent); color: var(--accent); background: var(--accent-soft); }\n.merchant-filter-chip { border-color: var(--orange); color: var(--orange); background: var(--orange-soft); }\n.category-filter-chip { border-color: var(--success); color: var(--success); background: #f0fdf4; }\n.search-filter-chip   { border-color: var(--danger); color: var(--danger); background: #fef2f2; }\n\n.chip-close-button {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  color: currentColor;\n  opacity: 0.6;\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n  transition: opacity 0.15s, transform 0.15s;\n  line-height: 1;\n}\n\n.chip-close-button:hover {\n  opacity: 1;\n  transform: scale(1.2);\n}\n\n.clear-all-filters {\n  background: white;\n  border: 1.5px solid var(--border);\n  border-radius: 100px;\n  padding: 5px 14px;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  color: var(--accent);\n  cursor: pointer;\n  transition: all 0.18s var(--ease);\n  box-shadow: var(--shadow-sm);\n}\n\n.clear-all-filters:hover {\n  background: var(--accent-soft);\n  border-color: var(--accent);\n  transform: translateY(-1px);\n}\n\n/* ======================================\n   PAGINATION\n====================================== */\n.pagination-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  margin: 32px 0 16px;\n  flex-wrap: wrap;\n}\n\n.pagination-container button {\n  min-width: 38px;\n  height: 38px;\n  padding: 0 12px;\n  border: 1.5px solid var(--border);\n  background: var(--surface);\n  color: var(--text-primary);\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 600;\n  cursor: pointer;\n  border-radius: 100px;\n  box-shadow: var(--shadow-sm);\n  transition: all 0.18s var(--ease);\n}\n\n.pagination-container button:hover:not(:disabled) {\n  background: var(--accent-soft);\n  border-color: var(--accent);\n  color: var(--accent);\n  transform: translateY(-1px);\n}\n\n.pagination-container button.active,\n.pagination-container button[aria-current=\"page\"] {\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\n  border-color: var(--accent);\n  color: white;\n  box-shadow: 0 3px 10px var(--accent-glow);\n}\n\n.pagination-container button:disabled {\n  background: var(--surface-2);\n  color: var(--text-muted);\n  cursor: not-allowed;\n  border-color: var(--border);\n  box-shadow: none;\n}\n\n.pagination-container span {\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-secondary);\n  padding: 0 8px;\n}\n\n/* ======================================\n   LOADING SPINNER\n====================================== */\n.flipkart-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 240px;\n}\n\n.spinner-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.spinner {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: 3px solid var(--accent-soft);\n  border-top-color: var(--accent);\n  animation: spin 0.7s linear infinite;\n  box-shadow: 0 0 16px var(--accent-glow);\n}\n\n.small-spinner {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid rgba(255,255,255,0.3);\n  border-top-color: white;\n  animation: spin 0.7s linear infinite;\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 6px;\n}\n\n@keyframes spin { to { transform: rotate(360deg); } }\n\n.loading-text {\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--accent);\n  letter-spacing: 0.3px;\n}\n\n/* ======================================\n   SKELETON LOADING\n====================================== */\n.flipkart-loading-skeleton {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n  gap: 16px;\n  padding: 0;\n}\n\n.product-skeleton {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  padding: 12px;\n  overflow: hidden;\n}\n\n.skeleton-image,\n.skeleton-line,\n.skeleton-button {\n  background: linear-gradient(90deg, #f0f2f5 25%, #e4e7ed 50%, #f0f2f5 75%);\n  background-size: 200% 100%;\n  animation: shimmer 1.4s infinite;\n  border-radius: var(--radius-sm);\n}\n\n.skeleton-image { width: 100%; height: 160px; margin-bottom: 14px; }\n.skeleton-line  { height: 11px; margin-bottom: 8px; }\n.skeleton-line.short  { width: 55%; }\n.skeleton-line.medium { width: 75%; }\n.skeleton-line.long   { width: 90%; }\n.skeleton-button      { height: 34px; width: 100%; margin-top: 14px; border-radius: 100px; }\n\n@keyframes shimmer {\n  0%   { background-position: -200% 0; }\n  100% { background-position:  200% 0; }\n}\n\n/* ======================================\n   EMPTY / ERROR STATES\n====================================== */\n.no-items-found-container,\n.no-results-message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  text-align: center;\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  margin: 8px 0;\n}\n\n.no-items-found-illustration,\n.no-results-icon { font-size: 48px; margin-bottom: 16px; opacity: 0.5; }\n\n.no-items-found-title,\n.no-results-message h3 {\n  font-family: var(--font);\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 8px;\n}\n\n.no-items-found-message,\n.no-results-message p {\n  font-size: 13.5px;\n  color: var(--text-secondary);\n  line-height: 1.6;\n  max-width: 320px;\n  margin-bottom: 20px;\n}\n\n.simple-error-message,\n.immediate-error-message {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 18px;\n  background: #fef2f2;\n  border: 1px solid rgba(239,68,68,0.25);\n  border-radius: var(--radius-sm);\n  margin: 16px 0;\n  animation: fadeIn 0.2s ease;\n}\n\n.error-icon {\n  width: 26px;\n  height: 26px;\n  background: var(--danger);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  flex-shrink: 0;\n  font-size: 13px;\n}\n\n.error-text {\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 500;\n  color: #b91c1c;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-4px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n/* ======================================\n   WISHLIST TOAST POPUP\n====================================== */\n.wishlist-popup-shop {\n  position: fixed;\n  top: 88px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(15,17,23,0.88);\n  backdrop-filter: blur(8px);\n  color: white;\n  padding: 12px 22px;\n  border-radius: 100px;\n  z-index: 9999;\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 600;\n  letter-spacing: 0.2px;\n  box-shadow: var(--shadow-lg);\n  white-space: nowrap;\n  animation: toastIn 0.25s var(--ease);\n}\n\n@keyframes toastIn {\n  from { opacity: 0; transform: translateX(-50%) translateY(-8px); }\n  to   { opacity: 1; transform: translateX(-50%) translateY(0); }\n}\n\n.goto-cart-button-shop {\n  background: var(--accent);\n  border: none;\n  color: white;\n  padding: 6px 16px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  border-radius: 100px;\n  cursor: pointer;\n  margin-left: 12px;\n  transition: all 0.18s var(--ease);\n}\n\n.goto-cart-button-shop:hover {\n  background: var(--accent-dark);\n  transform: translateY(-1px);\n}\n\n/* ======================================\n   FILTER POPUP (mobile overlay)\n====================================== */\n.filter-popup {\n  display: none;\n  position: fixed;\n  inset: 0;\n  background: rgba(15,17,23,0.45);\n  backdrop-filter: blur(5px);\n  z-index: 102;\n  overflow-y: auto;\n}\n\n.filter-popup.open {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.filter-popup-content {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 28px 24px;\n  width: 90%;\n  max-width: 480px;\n  box-shadow: var(--shadow-lg);\n  animation: modalIn 0.25s var(--ease);\n}\n\n@keyframes modalIn {\n  from { opacity: 0; transform: scale(0.95) translateY(12px); }\n  to   { opacity: 1; transform: scale(1) translateY(0); }\n}\n\n.filter-popup label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.8px;\n  color: var(--text-muted);\n  font-family: var(--font);\n  margin-bottom: 6px;\n}\n\n.filter-popup button[type=\"submit\"] {\n  background: linear-gradient(135deg, var(--accent), var(--accent-dark));\n  color: white;\n  padding: 11px 22px;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n  box-shadow: 0 3px 10px var(--accent-glow);\n  transition: all 0.2s var(--ease);\n  margin-top: 12px;\n}\n\n.filter-popup button[type=\"submit\"]:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px var(--accent-glow);\n}\n\n.filter-popup .close-button,\n.close-filter-button {\n  background: var(--surface-2);\n  color: var(--text-secondary);\n  border: 1.5px solid var(--border);\n  padding: 11px 18px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-left: 10px;\n  transition: all 0.18s var(--ease);\n}\n\n.filter-popup .close-button:hover,\n.close-filter-button:hover {\n  background: var(--border);\n  color: var(--text-primary);\n}\n\n/* ======================================\n   FILTER REC BUTTONS\n====================================== */\n.filter-rec-btn-s {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.filter-rec-btn-s button {\n  background: var(--surface-2);\n  border: 1.5px solid var(--border);\n  color: var(--text-secondary);\n  font-family: var(--font);\n  font-size: 12px;\n  font-weight: 600;\n  padding: 5px 12px;\n  border-radius: 100px;\n  cursor: pointer;\n  transition: all 0.18s var(--ease);\n}\n\n.filter-rec-btn-s button:hover {\n  background: var(--accent-soft);\n  border-color: var(--accent);\n  color: var(--accent);\n}\n\n/* ======================================\n   NAV ICON\n====================================== */\n.nav-icons-navbar-s {\n  height: 36px;\n  margin-right: 0;\n  font-size: 20px;\n  color: var(--text-secondary);\n  transition: color 0.18s;\n}\n\n.nav-icons-navbar-s:hover { color: var(--accent); }\n\n/* ======================================\n   ADD CARD BUTTON\n====================================== */\n.add-card-button {\n  padding: 10px 22px;\n  background: linear-gradient(135deg, var(--orange), #e65100);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: 0 3px 10px rgba(255,109,0,0.28);\n  transition: all 0.2s var(--ease);\n  margin-left: auto;\n  display: block;\n  white-space: nowrap;\n}\n\n.add-card-button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 18px rgba(255,109,0,0.38);\n}\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n@media (max-width: 1024px) and (min-width: 768px) {\n  .shop_js-shop { grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)); gap: 12px; }\n  .card-image-shop { height: 155px; }\n  .filter { width: 220px; }\n}\n\n@media (max-width: 768px) {\n  .shop-div { margin-top: 70px; padding: 16px 12px 48px; }\n\n  .filter-products-main-box { flex-direction: column; }\n\n  .filter {\n    position: fixed;\n    top: 70px;\n    left: -280px;\n    width: 260px;\n    max-height: 90vh;\n    z-index: 100;\n    overflow-y: auto;\n    border-radius: 0 var(--radius-lg) var(--radius-lg) 0;\n    transition: left 0.3s var(--ease);\n  }\n\n  .filter.open { left: 0; }\n\n  .filter-button { display: flex; align-items: center; gap: 6px; }\n\n  .navigation_shop_card {\n    flex-wrap: wrap;\n    border-radius: var(--radius-sm);\n    padding: 10px 12px;\n    gap: 8px;\n  }\n\n  .shop_js-shop {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n  }\n\n  .card-image-shop { height: 150px; }\n\n  .shop_card-shop { border-radius: var(--radius-sm); }\n}\n\n@media (max-width: 480px) {\n  .shop_js-shop { grid-template-columns: repeat(2, 1fr); gap: 8px; }\n  .card-image-shop { height: 130px; }\n  .shop_container-shop { padding: 9px 10px 11px; }\n  .cart-btn-shop { font-size: 11.5px; padding: 9px 10px; }\n  .price-discounted { font-size: 14px; }\n  .shop-div { padding: 12px 8px 40px; }\n}\n/* ── Shop page star rating badge (Flipkart/Amazon style) ── */\n.shop-star-rating {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  margin: 3px 0 5px;\n}\n\n.shop-star-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  background: #388e3c;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 700;\n  padding: 2px 7px;\n  border-radius: 3px;\n  line-height: 1.5;\n}\n\n.shop-star-icon {\n  font-size: 11px;\n  line-height: 1;\n}\n\n.shop-rating-count {\n  font-size: 11.5px;\n  color: #878787;\n  font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
